import { render, staticRenderFns } from "./freetable.vue?vue&type=template&id=5149ead7&scoped=true"
import script from "./freetable.vue?vue&type=script&lang=js"
export * from "./freetable.vue?vue&type=script&lang=js"
import style0 from "./freetable.vue?vue&type=style&index=0&id=5149ead7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5149ead7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5149ead7')) {
      api.createRecord('5149ead7', component.options)
    } else {
      api.reload('5149ead7', component.options)
    }
    module.hot.accept("./freetable.vue?vue&type=template&id=5149ead7&scoped=true", function () {
      api.rerender('5149ead7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/modules/freetable.vue"
export default component.exports